import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureUtmData } from '../utils/utmTracker';

export const useUtmTracker = () => {
  const location = useLocation();

  useEffect(() => {
    captureUtmData();
  }, [location]);
};
